import Controller from "./login.controller";
import template from "./login.html";

const loginPage = {
  template,
  controller: Controller,
};

export default loginPage;



// WEBPACK FOOTER //
// ./src/pages/login/login.component.js